import { Routes } from '@angular/router';
import { authGuard } from './core/guards/auth.guard';

export const routes: Routes = [
  {
    path: 'login',
    loadChildren: () =>
      import('./features/login/login.routes').then(m => m.LOGIN_ROUTES),
  },
  {
    path: '',
    redirectTo: 'notices',
    pathMatch: 'full',
  },
  {
    path: 'notices',
    canActivate: [authGuard],
    loadChildren: () =>
      import('./features/notices/notices.routes').then(m => m.NOTICES_ROUTES),
  },
  {
    path: 'modules',
    canActivate: [authGuard],
    loadChildren: () =>
      import('./features/modules/modules.routes').then(m => m.MODULES_ROUTES),
  },
  {
    path: 'tracks',
    canActivate: [authGuard],
    loadChildren: () =>
      import('./features/tracks/tracks.routes').then(m => m.TRACKS_ROUTES),
  },
  {
    path: 'track-enrollments',
    canActivate: [authGuard],
    loadChildren: () =>
      import('./features/enrollments/enrollments.routes').then(m => m.ENROLLMENTS_ROUTES),
  },
];
